import { WorkflowEventTypes } from '@amzn/awscat-pattern-library-service-model';
import delay from 'delay';
import React from 'react';
import constants from '../../../common/constants';
import { withAppContext } from '../../../contexts/AppContext';
import ModalDialogButtonV3 from '../../common/ModalDialogButtonV3';
import WorkflowControls from './WorkflowControls';

class PublishingControls extends WorkflowControls {
  protected showCommentForm: boolean = true;

  protected renderActionControls(disabled: boolean) {
    return (
      <div>
        <ModalDialogButtonV3
          variant="normal"
          header={constants.PUBLISH_ACTION_MODAL_HEADER}
          text={constants.PUBLISH_REJECT_MODAL_CONTENT}
          onBeforeOpenModal={this.validateInputs}
          onSubmit={this.rejectWorkflow}
          submitButtonText={constants.REJECT_PUBLICATION_BUTTON_TEXT}
          disabled={disabled}
        />
        <ModalDialogButtonV3
          variant="primary"
          header={constants.PUBLISH_ACTION_MODAL_HEADER}
          text={constants.PUBLISH_MODAL_CONTENT}
          onBeforeOpenModal={this.validateInputs}
          onSubmit={this.publishWorkflow}
          submitButtonText={constants.PUBLISH_BUTTON_TEXT}
          disabled={disabled}
        />
      </div>
    );
  }

  private lockWorkflow = async () => {
    await this.sendWorkflowEvent(WorkflowEventTypes.LOCK);
    await this.afterActionSuccess();
  };

  private rejectWorkflow = async () => {
    await this.sendWorkflowEvent(WorkflowEventTypes.REJECT);
    await this.afterActionSuccess();
  };

  private publishWorkflow = async () => {
    await this.sendWorkflowEvent(WorkflowEventTypes.PUBLISH);
    await this.afterActionSuccess();
  };

  private afterActionSuccess = async () => {
    const { onActionSuccess } = this.props;
    if (onActionSuccess) {
      await onActionSuccess();
    }
  };
}

export default withAppContext(PublishingControls);
